// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// import menuOpen from './menuOpen';
// import infiniteScroll from './infiniteScroll';

const privacyModal = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const body = document.querySelector('body');
    const privacyLink = body.querySelector('#contact .kg-product-card .kg-product-card-button');
    const privacySection = body.querySelector('#privacy');
    const hiddenClassName = 'is-hidden';
    const modalOpenClassName = 'is-modal-open';

    const handleToggleModal = (e) => {
      e.stopPropagation();

      if (privacySection.classList.contains(hiddenClassName)) {
        privacySection.classList.remove(hiddenClassName)
        body.classList.add(modalOpenClassName)
        privacySection.scrollTop = 0;
      } else {
        privacySection.classList.add(hiddenClassName)
        body.classList.remove(modalOpenClassName)
      }

      return false;
    }

    if (privacyLink && privacySection) {
      privacyLink.onclick = handleToggleModal;

      privacySection.querySelectorAll('.kg-btn').forEach(closeButton => {
        closeButton.onclick = handleToggleModal;
      });
    }
  });
}

import '../css/index.css';

// menuOpen();
// infiniteScroll();
privacyModal();
